var map = {
	"./buliding.svg": "20fd",
	"./checked.svg": "0aae",
	"./clipboard-tick.svg": "23e6",
	"./cup.svg": "5e13",
	"./data.svg": "e756",
	"./document-text.svg": "95bc",
	"./document.svg": "4aa0",
	"./lamp-charge.svg": "ef8f",
	"./office-chat.svg": "24b28",
	"./people-2.svg": "9616",
	"./people.svg": "1a5b",
	"./presentation.svg": "b097",
	"./presention-chart.svg": "89e4",
	"./project-timeline.svg": "608d",
	"./ranking.svg": "2b4a",
	"./search-plus.svg": "9220",
	"./setting-2.svg": "35e4",
	"./sms-tracking.svg": "bc71",
	"./stars.svg": "fe08",
	"./status-up.svg": "455c",
	"./unchecked.svg": "0cab",
	"./user-tick.svg": "9d51",
	"./verify.svg": "945e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";